import React, { useState } from 'react';
import './Project.css'
import ProjectDetail from '../ProjectDetail/ProjectDetail';
import project from '../../FakeData/ProjectFakeData'
import Header from '../Header/Header'


const Project = () => {

    const [projectData, setProjectData] = useState(project)

    return (
        <div className="project-detail">
            <Header></Header>
            {
                projectData.map(project => <ProjectDetail project={project}></ProjectDetail>)
            }
        </div>
    );
};

export default Project;